import owd from 'owd/owd';

export default class MenuHome extends owd.Component {
	init() {
        this.photo = this.$element.find('[data-menu-home-photo]');
        this.bgTop = this.$element.find('[data-menu-home-content-top]');
        this.bgBottom = this.$element.find('[data-menu-home-content-bottom]');

        this.default = {
            photo: this.photo.data('menu-home-photo'),
            bgTop: this.bgTop.data('menu-home-content-top'),
            bgBottom: this.bgBottom.data('menu-home-content-bottom'),
        }
        
        this.links = this.$element.find('[data-menu-home-item]');

		this.bind();
    }

    fetchImage(url) {
        return new Promise((resolve, reject) => {
            const image = new Image();

            image.src = url;
            image.onload = resolve;
            image.onerror = reject;
        });
    }

    loadImage(image, src) {
        return this.fetchImage(src);
    }
    
    updateTiles(photo, bgTop, bgBottom) {
        this.photo.fadeOut(200, () => {
            this.loadImage(this.photo[0], photo).then(() => {
                this.photo[0].src = photo;

                this.photo.fadeIn(250);
            });
        });

        this.bgTop.css({
            backgroundColor: bgTop,
        });

        this.bgBottom.css({
            backgroundColor: bgBottom,
        });
    }

	bind() {
        this.on('mouseover', this.links, (e) => {
            const activeLink = this.links.filter(e.currentTarget);
            
            const photo = activeLink.data('image');
            const bgTop = activeLink.data('bg-top');
            const bgBottom = activeLink.data('bg-bottom');

            this.updateTiles(photo, bgTop, bgBottom);

        });

        this.on('mouseout', this.links, () => {
            this.updateTiles(this.default.photo, this.default.bgTop, this.default.bgBottom);
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('menu-home', {
	component: MenuHome
});
